import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"

export const operatorReportApi = createApi({
  reducerPath: "operatorReportApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/analytics/" }),
  tagTypes: ["OperatorCalls"],
  endpoints: builder => ({
    getOperators: builder.query<any, any>({
      query: params => ({
        url: "operators",
        params,
      }),
    }),
    getCallTypes: builder.query<any, any>({
      query: params => ({
        url: "call-types",
        params,
      }),
    }),
    getOperatorCalls: builder.query<
      any,
      {
        page?: number
        limit?: number
        startDate?: string
        endDate?: string
        operatorId?: number
        orderBy?: string
        callTypeId?: number
        organizationId: number
        intentDirection?: string
        criteria?: string
        text?: string
        debugSample?: boolean
      }
    >({
      query: params => ({
        url: "operator-calls-json",
        params,
      }),
      providesTags: ["OperatorCalls"],
    }),
    updateFileApprovalAndComment: builder.mutation<any, any>({
      query: ({ id, ...body }) => ({
        url: `updateFileApprovalAndComment/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["OperatorCalls"],
    }),
    summarizeCall: builder.mutation<{ text: string }, { fileId: number }>({
      query: ({ fileId }) => ({
        url: `summarize/${fileId}`,
        method: "POST",
      }),
      invalidatesTags: ["OperatorCalls"],
    }),
  }),
})

export const {
  useGetOperatorCallsQuery,
  useGetCallTypesQuery,
  useGetOperatorsQuery,
  useUpdateFileApprovalAndCommentMutation,
  useSummarizeCallMutation,
} = operatorReportApi
